import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* eslint-disable sort-keys */
import { useTheme } from '@mui/material/styles';
import { useState, useEffect, useCallback } from 'react';

/**
 * Utility hook to get the current breakpoint of a container using refs which updates as the
 * element changes width.
 * @ref The ref of the container/element you want to measure.
 */
export var useContainerBreakpoint = function useContainerBreakpoint(ref) {
  var theme = useTheme();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var updateWidth = useCallback(function () {
    if (ref.current) {
      setWidth(ref.current.offsetWidth);
    }
  }, [ref]);
  useEffect(function () {
    var element = ref.current;
    if (!element) {
      console.warn('useElementWidth: Ref current is null. Element not found.');
      return;
    }
    var observer = new ResizeObserver(function (entries) {
      var _iterator = _createForOfIteratorHelper(entries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          setWidth(entry.contentRect.width);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe(element);
    updateWidth();
    return function () {
      observer.disconnect();
    };
  }, [ref, updateWidth]);
  var isMobile = width < theme.breakpoints.values.sm;
  var isTablet = width >= theme.breakpoints.values.sm && width < theme.breakpoints.values.md;
  var isDesktopSmall = width >= theme.breakpoints.values.md && width < theme.breakpoints.values.lg;
  var isDesktop = width >= theme.breakpoints.values.lg && width < theme.breakpoints.values.xl;
  var isDesktopLarge = width >= theme.breakpoints.values.xl;

  /**
   * Returns the current breakpoint of the ref element, like 'xs'
   */
  var getBreakpoint = function getBreakpoint() {
    if (isMobile) return 'xs';
    if (isTablet) return 'sm';
    if (isDesktopSmall) return 'md';
    if (isDesktop) return 'lg';
    if (isDesktopLarge) return 'xl';
    return 'lg';
  };

  /** Utility function to determine if a container width is smaller than the specified breakpoint */
  var isContainerDown = function isContainerDown(breakpoint) {
    var breakpointValue = theme.breakpoints.values[breakpoint];
    return width < breakpointValue;
  };

  /** Utility function to determine if a container width is equal to or greater than the specified breakpoint */
  var isContainerUp = function isContainerUp(breakpoint) {
    var breakpointValue = theme.breakpoints.values[breakpoint];
    return width >= breakpointValue;
  };
  return {
    getBreakpoint: getBreakpoint,
    isContainerDown: isContainerDown,
    isContainerUp: isContainerUp,
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktopSmall: isDesktopSmall,
    isDesktop: isDesktop,
    isDesktopLarge: isDesktopLarge,
    width: width
  };
};